// Formato de los números y la moneda en la vista previa del lector de
// facturas (energía, agua, …). Solo visual: lo que se guarda no cambia.

// Moneda local que devuelve cada parser de país (código ISO). Varios países
// usan "$": por eso la vista muestra además el código (ARS, MXN, COP…).
export const INVOICE_CURRENCY_SYMBOLS = {
  ARS: "$", BRL: "R$", USD: "US$", MXN: "$", COP: "$", PYG: "₲", PEN: "S/",
  EUR: "€", GTQ: "Q", HNL: "L", NIO: "C$", UYU: "$U", CLP: "$", CRC: "₡", DOP: "RD$", BOB: "Bs",
};

const ZERO_DECIMAL_CURRENCIES = ["PYG", "CLP"]; // sin centavos

// Separadores según el idioma de la app (es: 8.387.700,00 — en: 8,387,700.00)
const LOCALE_BY_LANGUAGE = { es: "es-AR", pt: "pt-BR", fr: "fr-FR", en: "en-US" };

export const invoiceNumberLocale = (language) => LOCALE_BY_LANGUAGE[language] || "es-AR";

export const invoiceCurrencySymbol = (currency) => INVOICE_CURRENCY_SYMBOLS[currency] || "$";

export const formatInvoiceAmount = (n, currency, language) => {
  const decimals = ZERO_DECIMAL_CURRENCIES.includes(currency) ? 0 : 2;
  return Number(n).toLocaleString(invoiceNumberLocale(language), { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

export const formatInvoiceQuantity = (n, language) =>
  Number(n).toLocaleString(invoiceNumberLocale(language), { maximumFractionDigits: 3 });

// Estilo de la etiqueta con el código de moneda al lado del costo.
export const INVOICE_CURRENCY_BADGE_STYLE = {
  marginLeft: "0.4rem", background: "#eef3f8", color: "#2c5282", borderRadius: "4px",
  padding: "1px 6px", fontSize: "0.72rem", fontWeight: 600,
};
